import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const LinkRedirect = () => {
	const [searchParams] = useSearchParams();
	const [code, setCode] = useState('');
	const [codes, setCodes] = useState<string[]>([]);
	const [status, setStatus] = useState('loading');

	useEffect(() => {
		const codeParam = searchParams.get('code');
		const codesParam = searchParams.get('codes');

		if (codesParam) {
			// Multiple codes
			const codeArray = codesParam.split(',').filter((c) => c.trim());
			setCodes(codeArray);

			// Deep Link zur App mit mehreren Codes
			const appDeepLink = `erledix://link-child?codes=${codesParam}`;
			window.location.href = appDeepLink;

			setTimeout(() => {
				setStatus('manual');
			}, 2000);
		} else if (codeParam) {
			// Single code
			setCode(codeParam);

			const appDeepLink = `erledix://link-child?code=${codeParam}`;
			window.location.href = appDeepLink;

			setTimeout(() => {
				setStatus('manual');
			}, 2000);
		} else {
			setStatus('error');
		}
	}, [searchParams]);

	return (
		<div style={styles.body}>
			<div style={styles.container}>
				<div style={styles.logo}>🎯</div>
				<h1 style={styles.h1}>Kinderprofil verknüpfen</h1>

				<div style={styles.content}>
					{status === 'loading' && (
						<>
							<div style={styles.spinner}></div>
							<p style={styles.message}>App wird geöffnet...</p>
						</>
					)}

					{status === 'error' && (
						<div style={styles.statusError}>
							<p>❌ Kein Code gefunden</p>
							<p style={{ marginTop: '10px', fontSize: '14px' }}>
								Bitte verwende den Link aus der Einladung.
							</p>
						</div>
					)}

					{status === 'manual' && codes.length > 0 && (
						<>
							<p style={styles.message}>
								{codes.length} Kinderprofile werden verknüpft
							</p>
							<div style={{ marginBottom: '20px' }}>
								{codes.map((c, i) => (
									<div key={i} style={styles.codeItem}>
										<span style={{ color: '#667eea', marginRight: '8px' }}>
											✓
										</span>
										<span style={styles.code}>{c}</span>
									</div>
								))}
							</div>
							<p style={styles.message}>
								Falls die App nicht automatisch geöffnet wurde:
							</p>
							<a
								href={`erledix://link-child?codes=${codes.join(',')}`}
								style={styles.button}
							>
								App öffnen
							</a>
						</>
					)}

					{status === 'manual' && code && (
						<>
							<div style={styles.code}>{code}</div>
							<p style={styles.message}>
								Falls die App nicht automatisch geöffnet wurde:
							</p>
							<a href={`erledix://link-child?code=${code}`} style={styles.button}>
								App öffnen
							</a>
							<p style={{ ...styles.message, marginTop: '20px', fontSize: '14px' }}>
								Oder gib den Code manuell in der App ein
							</p>
						</>
					)}
				</div>
			</div>

			<style>{keyframes}</style>
		</div>
	);
};

const styles = {
	body: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: '100vh',
		backgroundColor: '#f5f5f5',
		fontFamily: 'Arial, sans-serif',
	},
	container: {
		textAlign: 'center' as const,
		backgroundColor: 'white',
		padding: '40px',
		borderRadius: '12px',
		boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
		maxWidth: '500px',
	},
	logo: {
		fontSize: '48px',
		marginBottom: '20px',
	},
	h1: {
		color: '#333',
		marginBottom: '30px',
		fontSize: '24px',
	},
	content: {
		marginTop: '20px',
	},
	spinner: {
		border: '4px solid #f3f3f3',
		borderTop: '4px solid #667eea',
		borderRadius: '50%',
		width: '40px',
		height: '40px',
		animation: 'spin 1s linear infinite',
		margin: '0 auto 20px',
	},
	message: {
		color: '#666',
		fontSize: '16px',
		marginTop: '10px',
	},
	statusError: {
		color: '#d32f2f',
		padding: '20px',
		backgroundColor: '#ffebee',
		borderRadius: '8px',
	},
	codeItem: {
		display: 'flex',
		alignItems: 'center',
		padding: '10px',
		backgroundColor: '#f7f7f7',
		borderRadius: '8px',
		marginBottom: '8px',
	},
	code: {
		fontFamily: 'monospace',
		fontSize: '14px',
		color: '#333',
	},
	button: {
		display: 'inline-block',
		backgroundColor: '#667eea',
		color: 'white',
		padding: '12px 24px',
		borderRadius: '8px',
		textDecoration: 'none',
		marginTop: '20px',
		cursor: 'pointer',
		fontSize: '16px',
		transition: 'background-color 0.3s',
	},
};

const keyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export default LinkRedirect;
